import type { DiffFlattenTreeAnyItem } from "@ext/git/core/GitDiffItemCreator/RevisionDiffPresenter";

export const getDiscardPaths = (item: DiffFlattenTreeAnyItem): string[] => {
	if (item.type === "node") return [];

	const paths = [item.filepath.new, item.filepath.old];
	if (item.type === "item")
		item.resources?.forEach((resource) => paths.push(resource.filePath.path, resource.filePath.oldPath));

	return paths.filter(Boolean);
};
